__turbopack_context__.v({
  "filterActief": "filters-actief-module-scss-module__yc-M5W__filterActief",
  "filterActiefBtn": "filters-actief-module-scss-module__yc-M5W__filterActiefBtn",
  "filterActiefComponent": "filters-actief-module-scss-module__yc-M5W__filterActiefComponent",
  "filtersActiefContainer": "filters-actief-module-scss-module__yc-M5W__filtersActiefContainer",
  "headerContainer": "filters-actief-module-scss-module__yc-M5W__headerContainer",
  "resetFilterIcon": "filters-actief-module-scss-module__yc-M5W__resetFilterIcon",
});
